import styled from 'styled-components';

import {EditButton} from '../Article/styles';

const EditVideoButton = styled(EditButton)`
  padding:0;
  width:85px;
`;

const VideoContainer = styled.div`
  width: 100%;
  float: left;
  margin: 0 auto;
  margin-top: 20px;
  margin-top: ${({margin}) => margin ? '0px' : '20px'};
  background: white;
  
  > div {
    width: 100% !important;
  }
  .react-player {
    height: 480px !important;
    height: ${({width}) => width ? '480px !important' : '480px !important'};
    @media (max-width: 500px) {
      height: 200px !important;
    }
    @media (max-width: 1500px) {
      height: 395px !important;
    }
    >div{
      border-radius: 6px 6px 0 0;
    }
  }

  .react-player-webinar {
    height: 400px !important;
    @media (max-width: 500px) {
      height: 200px !important;
    }
  }
`;

const VideoContainerNew = styled.div`
  width: 100%;
  float: left;
  margin: 0 auto;
  margin-top: 20px;
  margin-top: ${({margin}) => margin ? '0px' : '20px'};
  background: white;
  
  > div {
    width: 100% !important;
  }
  .react-player {
    height: 470px !important;
    @media (max-width: 500px) {
      height: 200px !important;
    }

    @media (max-width: 1490px) {
      height: 451px !important;
    }
    @media (max-width: 1465px) {
      height: 440px !important;
    }
    @media (max-width: 1435px) {
      height: 430px !important;
    }
    @media (max-width: 1410px) {
      height: 420px !important;
    }
    @media (max-width: 1385px) {
      height: 410px !important;
    }
    @media (max-width: 1360px) {
      height: 400px !important;
    }
    @media (max-width: 1335px) {
      height: 390px !important;
    }
    @media (max-width: 1305px) {
      height: 380px !important;
    }
    @media (max-width: 1280px) {
      height: 370px !important;
    }
 
    >div{
      border-radius: 6px 6px 0 0;
    }
  }

  .react-player-webinar {
    height: 400px !important;
    @media (max-width: 500px) {
      height: 200px !important;
    }
  }
`;

const Layout = styled.div`
  width: 100%;
  display: block;
  .float {
    width; 100%;
    float; left;
  }
>div:first-child{
  width: 100%;
}
> div: last-child {
  width: 100%;
 
}
  @media (max-width: 500px) {
    padding: 0 10px 30px;
  }
  `;

const RelatedCardContainer = styled.div`
  background:white;
  padding:8px;
  height:${({ height }) => height?height:"299px"};
  display: flex;
  flex-wrap: wrap;
  width: calc((100% - 40px) / 3);
  border-radius: 6px;
  margin: ${({ margin }) => margin?margin:""};
  margin-right:20px;
  @media(max-width: 600px) {
    width: 100%;
  }

  .flex-item:not(:nth-child(3n)) {
  margin-right: 0;
}
&:nth-child(3n){
    margin-right: 0;
  }

  border-radius: 8px;
border: 1px solid #DCDCDC;

`;

const RelatedCard = styled.div`
  background-color: rgba(254, 254, 254, 0.60);
  float: left;
  border-radius: 4px;
  ${'' /* margin-bottom: 25px; */}
  padding: 0px!important;
  //width: 100%;
  width: 400px;
  ${'' /* height: 308px; */}
  display: flex;
  flex-wrap: wrap;
  position: relative;
  // box-shadow: 0px 8px 25px 0px #0D427040;
  .details{
    display:flex;
    align-items: center; 
    width:100%;
    height: 48px; 
    margin-top:16px;
  }

  .name{
    color: #184A61;
     font-family: Lato;
     font-size: 18px;
     font-style: normal;
     font-weight: 700;
     line-height: 24px; 
     ${'' /* width:60%; */}
     white-space: normal;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
  }
  .left-col{
    display:flex;
    align-items:center;
  }
  img {
    width: 100%;
    height: 250px;
    float: left;
    cursor:pointer;
  }

  .educateImageBackground {
    position: absolute;
    top: 0;
    width: 100%;
    height: 218px;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px 6px 0 0;
    .getStarted {
      font-family: 'Lato';
      font-weight: 400;
      font-size: 16px;
      font-style: normal;
      width: 200px;
      height: 40px;
      line-height: 20px;
      gap: 8px;
      background: #DA6C74;
      color: #FEFEFE;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      cursor: pointer;
      text-align:center;
      align-items: center;
      padding: 12px 16px;
      >img{
        width:24px;
        height:24px;
        margin-right:12px;
      }
    }
  }
`;

export { VideoContainer, EditVideoButton, Layout, VideoContainerNew,RelatedCard,RelatedCardContainer };